import { useMutation } from "@apollo/client"
import { client } from "../graphql-saleor/client"
import { CHECKOUT_EMAIL_UPDATE } from "../graphql-saleor/mutations/checkoutEmailUpdateMutation"

export const useCheckoutEmailUpdateMutation = () => {
  const [checkoutEmailUpdateMutation, { data, loading, error }] = useMutation(CHECKOUT_EMAIL_UPDATE, { client: client })
  return {
    data: data,
    error,
    loading,
    checkoutEmailUpdateMutation,
  }
}
